import { css } from "styled-components";
// import sortAscIcon from "../../../assets/images/sort_asc.png";

export const adminTableBase = css`
  text-align: left;
  margin: 0;
  padding: 0;
  background: #fff;
  border-right: 0;
  color: #333;
  border-spacing: 0;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 11px;
  width: 100%;
  border-collapse: separate;
`;

export const adminTableHead = css`
  text-align: left;
  color: #333;
  border-spacing: 0;
  font-size: 12px;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  padding: 0;
`;

export const adminTableBody = css`
  text-align: left;
  color: #333;
  border-spacing: 0;
  font-size: 12px;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  padding: 0;
`;

export const adminTableRow = css`
  text-align: left;
  color: #333;
  border-spacing: 0;
  font-size: 12px;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  padding: 0;
`;

export const adminTableHeaderCell = css`
  color: #333;
  border-spacing: 0;
  font-size: 12px;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  border: 0;
  text-align: left;
  padding: 1em 10px;
  border-bottom: 1px solid #ddd;
  border-right: none;
  border-radius: 4px 0px 0px 0px;
  width: 331px;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 0.75em 8px;
  }
`;

export const adminTableDataCell = css`
  color: #333;
  border-spacing: 0;
  font-size: 12px;
  empty-cells: show;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  padding: 10px;
  vertical-align: middle;
  border-bottom: 1px solid #ddd;
  background: "transparent";
  text-align: left;
  // background-color: #fff;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 8px;
    word-break: break-word;
  }
`;

export const adminTableZebraRows = css`
  tbody tr:nth-child(odd) {
    background-color: #fff;
  }

  tbody tr:nth-child(even) {
    background-color: #f5f5f5;
  }
`;

export const adminTable = css`
  ${adminTableBase};
  ${adminTableZebraRows};

  thead {
    ${adminTableHead};
  }

  thead tr {
    ${adminTableRow};
  }

  thead th {
    ${adminTableHeaderCell};
  }

  tbody {
    ${adminTableBody};
  }

  tbody tr {
    ${adminTableRow};
  }

  tbody td {
    ${adminTableDataCell};
  }
`;
